import React from 'react';
import { useDispatch } from 'react-redux';

import {
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from '../../../../features';

import { QuestionAssuranceModal } from './QuestionAssuranceModal';

interface QuestionAssuranceProps {
    lienModale: string;
    titreModale: string;
    questionsPuces: React.JSX.Element;
}

export const QuestionAssuranceModalConnected: React.FC<
    QuestionAssuranceProps
> = ({ lienModale, titreModale, questionsPuces }) => {
    const dispatch = useDispatch();

    const handleOpenModalAnalytic = () => {
        dispatch(
            sendEvent({
                category: EVENT_CATEGORIES.RHN,
                action: EVENT_ACTIONS.CLIC,
                label: EVENT_LABELS.VOIR_DETAIL_QUESTIONS
            })
        );
    };

    return (
        <QuestionAssuranceModal
            lienModale={lienModale}
            titreModale={titreModale}
            questionsPuces={questionsPuces}
            onOpenModalAnalytic={handleOpenModalAnalytic}
        />
    );
};
